import EditLoyaltyPointDialogContainer from "./editLoyaltyPointDialog.container";

export default EditLoyaltyPointDialogContainer